import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import actions from "src/store/auth/actions";
import BiometricAuthentificationsModal from "../biometricsModals/biometricAuthentificationsModal";
import { useIsMobile } from "src/hooks/utils/deviceCheck";
import { useCheckForUser } from "src/hooks/useCheckForUser";

function PersonalNumberLogin({
  pId,
  setIsPasswordAuth,
  setIsPersonalNumber,
  nextText,
}) {
  const dispatch = useDispatch();
  const biometricLoginStatus = useSelector(
    (state) => state.auth.biometricLoginStatus
  );

  const biometricLogin = useSelector((state) => state.auth.biometricLogin);
  const handleNextWithoutBiometrics = () => {
    setIsPasswordAuth(true);
    setIsPersonalNumber(false);
  };
  const isMobile = useIsMobile();
  const isAllowedUser = useCheckForUser(pId);
  const handleNextButtonClick = () => {
    if (isAllowedUser && isMobile) {
      dispatch(actions.getBiometricLoginStatus({ userName: pId }));
    } else {
      handleNextWithoutBiometrics();
    }
  };
  useEffect(() => {
    if (
      biometricLoginStatus?.success === true &&
      biometricLoginStatus?.data?.biometricEnabled === true &&
      biometricLoginStatus?.data?.deviceEnrolled === true
    ) {
      dispatch(
        actions.getBiometricLogin({
          userName: pId,
        })
      );
    } else if (
      biometricLoginStatus?.success === false ||
      (biometricLoginStatus?.success === true &&
        (biometricLoginStatus?.data?.biometricEnabled === false ||
          biometricLoginStatus?.data?.deviceEnrolled === false))
    ) {
      handleNextWithoutBiometrics();
    }
  }, [biometricLoginStatus]);
  // useEffect(() => {
  //   if (biometricLogin?.success === false) {
  //     handleNextWithoutBiometrics();
  //   }
  // }, [biometricLogin]);
  const handleHideBiometricsAuthModal = () => {
    handleNextWithoutBiometrics();
  };
  const handleActivate = () => {
    dispatch(
      actions.getBiometricLogin({
        userName: pId,
      })
    );
  };

  return (
    <>
      <BiometricAuthentificationsModal
        showBiometricsAuthModal={biometricLogin?.success === false}
        handleHideBiometricsAuthModal={handleHideBiometricsAuthModal}
        isSuccess={false}
        isRetry={biometricLogin?.success === false}
        handleActivate={handleActivate}
      />
      <div className="text-center pt-4">
        <button
          className="btn btn-primary login-button"
          disabled={
            pId === "" ||
            !Boolean(pId) ||
            biometricLoginStatus?.success === undefined
          }
          onClick={handleNextButtonClick}
        >
          {nextText}
        </button>
      </div>
    </>
  );
}

export default PersonalNumberLogin;
